.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

/* The shared Card, as the page's one column; the form inside is kui-form on the shared fields. */
.card {
  width: 100%;
  max-width: 420px;
}

.logo {
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto var(--space-4);
}

.title {
  font-family: "Raleway", sans-serif;
  font-size: var(--text-3xl);
  font-weight: var(--font-semibold);
  color: var(--text);
  text-align: center;
  margin-bottom: var(--space-1);
}

.subtitle {
  color: var(--text-muted);
  text-align: center;
  margin-bottom: var(--space-6);
}

.error {
  background: var(--danger-bg);
  border: 1px solid var(--danger-border);
  color: var(--danger);
  padding: var(--space-3);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-4);
  font-size: var(--text-base);
}

.button {
  margin-top: var(--space-2);
}

.consent {
  color: var(--text-muted);
  font-size: var(--text-sm2);
  text-align: center;
}

.consent a {
  color: var(--link);
  text-decoration: none;
}

.consent a:hover {
  text-decoration: underline;
}

.loginLink {
  text-align: center;
  margin-top: var(--space-6);
  color: var(--text-muted);
  font-size: var(--text-base);
}

.loginLink a {
  color: var(--link);
  text-decoration: none;
}

.loginLink a:hover {
  text-decoration: underline;
}

.legalLinks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2) var(--space-4);
  margin-top: var(--space-4);
  font-family: "Raleway", sans-serif;
  font-size: var(--text-xs);
}

.legalLinks a {
  color: var(--text-muted);
  text-decoration: none;
}

.legalLinks a:hover {
  color: var(--link);
  text-decoration: underline;
}
